<template lang="pug">
  .nav.navbar-form.mainSearchForm#mainSearchForm(v-show='isVisible')
    div.form-group
      input.form-control(type="text", :placeholder="mainSearchPlaceHolder", required, ref="mainSearchInput", v-model="internalSearchText", @focus="focus", @blur="blur", @keydown="changeText")
      .overInput
        i.fa.fa-times(@click.stop="close", v-if="searchOpen || searchText")
        i.fa.fa-search(@click.stop="focus", v-if="!searchOpen && !searchText")
</template>
<script>
import {mapGetters} from 'vuex'
import Vue from 'vue'

import searchBus from '@/components/shared/SearchBus'

import _ from 'lodash'
// import $ from 'jquery'

import MousetrapManager from '@/components/shared/mousetrapManager'

export default {
  data () {
    return {
      internalSearchText: ''
    }
  },
  mounted () {
    MousetrapManager.bindAll({
      'f': (e) => { this.$refs.mainSearchInput.focus(); return false }
    }, 'Search')
  },
  computed: {
    ...mapGetters('search', [
      'searchObject',
      'searchOpen',
      'searchText'
    ]),
    ...mapGetters('groops', [
      'isAllGroopsSelected',
      'selectedGroopsString'
    ]),
    isVisible () {
      return this.viewName !== Vue.i18n.t('searchBar.thisView')
    },
    viewName () {
      switch (this.$route.name) {
        // case 'News':
        //   return Vue.i18n.t('searchBar.news')
        case 'Nodes':
          return Vue.i18n.t('searchBar.files')
        case 'Events':
          return Vue.i18n.t('searchBar.events')
        case 'Polls':
          return Vue.i18n.t('searchBar.polls')
        case 'Conversations':
          return Vue.i18n.t('searchBar.conversations')
        case 'GroupPage':
          return Vue.i18n.t('searchBar.groupPages')
        case 'Members':
          if (this.isAllGroopsSelected) {
            return Vue.i18n.t('searchBar.contacts')
          } else {
            return Vue.i18n.t('searchBar.members')
          }
        default:
          return Vue.i18n.t('searchBar.thisView')
      }
    },
    mainSearchPlaceHolder () {
      var str
      str = Vue.i18n.t('searchBar.searchIn') + this.viewName
      if (!this.isAllGroopsSelected && this.$route.name !== 'GroupPage') {
        str += Vue.i18n.t('searchBar.ofGroup') + this.selectedGroopsString
      }
      return str
    }
  },
  methods: {
    toggleSearch () {
      this.$store.dispatch('search/toggleOpen')
      this.$nextTick(() => {
        if (this.searchOpen) {
          this.$store.dispatch('search/setNewText', '')
        }
      })
    },
    close () {
      this.$store.dispatch('search/setNewText', '')
      this.blur()
    },
    focus () {
      this.$store.dispatch('search/open')
    },
    blur () {
      this.$store.dispatch('search/close')
    },
    changeText (event) {
      if (event.shiftKey) {
        return
      } else if (event.keyCode === 40) { // down arrow
        searchBus.$emit(searchBus.actions.KEY_DOWN)
        event.preventDefault()
      } else if (event.keyCode === 38) { // up arrow
        searchBus.$emit(searchBus.actions.KEY_UP)
        event.preventDefault()
      } else if (event.keyCode === 13) { // enter
        searchBus.$emit(searchBus.actions.KEY_ENTER)
        event.preventDefault()
      } else if (event.keyCode === 27) { // enter
        this.internalSearchText = ''
        setTimeout(() => {
          searchBus.$emit(searchBus.actions.KEY_ESCAPE)
          this.$refs.mainSearchInput.blur()
        }, 100)
        event.preventDefault()
      }
    }
  },
  watch: {
    searchText () {
      this.internalSearchText = this.searchText
      // setTimeout(() => {
      //   $(this.$refs.mainSearchInput).focus()
      // }, 10)
    },
    internalSearchText: _.debounce(function () {
      this.$store.dispatch('search/setNewText', this.internalSearchText)
    }, 200)
  }
}
</script>



// WEBPACK FOOTER //
// HeaderSearchForm.vue?d2dbdf72